module.exports = __webpack_public_path__ + "static/media/sprite.42d57aa1.svg";